(function () {
  const outingEventsPlayersApp = function () {
    const bindFileInput = () => {
      $('#import_csv').on('change', function(e) {
        if (this.files.length > 0) {
          var file_path_splited = $(this).val().split('\\');
          $('label[for="import_csv"]').html(file_path_splited[file_path_splited.length - 1]);
          $(e.target.form).find('[type=submit]').trigger('click');
        }
      })
    };

    const bindForm = () => {
      $('[enctype="multipart/form-data"').on('submit', function() {
        $('.loader').removeClass('d-none');
      })
    };

    const bindDeletePlayer = () => {
      $('.delete-player').on('click', function(e) {
        e.preventDefault();
        e.stopImmediatePropagation();
        const url = $(this).attr('href');

        window.swalConfirm.fire({
          text: 'If you submit this action you will lose the unsaved changes.',
          confirmButtonText: 'OK',
          cancelButtonText: 'Cancel',
        }).then(result => {
          if (!result.isConfirmed) return;

          $.ajax({ type: 'DELETE', url });
        });
      });
    };

    $(document).on('turbolinks:load', () => {
      if (!$('body').hasClass('controller-outings-players')) return;

      bindFileInput();
      bindForm();
      bindDeletePlayer();
    });
  };

  if (typeof window !== "undefined") {
    window.outingEventsPlayersApp = outingEventsPlayersApp();
  }
})();
